import React from "react";

export function SectionHeader({ icon: Icon, title, desc }) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-3">
        {Icon && <Icon className="h-4 w-4 text-[var(--magenta)]" />}
        <h2 className="font-fraunces italic text-2xl text-[var(--cream)]">{title}</h2>
      </div>
      {desc && (
        <p className="font-manrope text-sm text-[var(--cream-soft)] leading-relaxed">{desc}</p>
      )}
    </div>
  );
}

export function ToggleRow({ label, sub, checked, onChange, disabled, testId, vip }) {
  return (
    <label
      className={`flex items-start justify-between py-4 cursor-pointer gap-6 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      data-testid={testId}
    >
      <span className="min-w-0">
        <span className="font-manrope text-base text-[var(--cream)] block">
          {label}
          {vip && <span className="ml-2 inline-block px-1.5 py-0.5 text-[10px] uppercase tracking-wider bg-[var(--gold)]/20 text-[var(--gold)] border border-[var(--gold)]/30">VIP</span>}
        </span>
        {sub && <span className="font-manrope text-xs text-[var(--cream-soft)] block mt-1">{sub}</span>}
      </span>
      <input
        type="checkbox"
        disabled={disabled}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        className="h-5 w-5 accent-[var(--magenta)] shrink-0 mt-1"
      />
    </label>
  );
}

export function RadioRow({ name, value, current, label, sub, onChange, disabled, testId, vip }) {
  return (
    <label
      className={`flex items-start justify-between py-4 cursor-pointer gap-4 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      data-testid={testId}
    >
      <div>
        <div className="font-manrope text-base text-[var(--cream)]">
          {label}
          {vip && <span className="ml-2 inline-block px-1.5 py-0.5 text-[10px] uppercase tracking-wider bg-[var(--gold)]/20 text-[var(--gold)] border border-[var(--gold)]/30">VIP</span>}
        </div>
        {sub && <div className="font-manrope text-xs text-[var(--cream-soft)] mt-1">{sub}</div>}
      </div>
      <input
        type="radio"
        name={name}
        value={value}
        checked={current === value}
        onChange={() => onChange(value)}
        disabled={disabled}
        className="h-5 w-5 accent-[var(--magenta)] mt-0.5 shrink-0"
      />
    </label>
  );
}

export function RowGroup({ children }) {
  return <div className="border-y border-white/10 divide-y divide-white/5">{children}</div>;
}

export function SaveButton({ onClick, saving, disabled, testId, children = "Lagre endringer" }) {
  return (
    <button
      onClick={onClick}
      disabled={saving || disabled}
      className="btn-magenta inline-flex items-center gap-2 mt-6"
      data-testid={testId}
    >
      {saving ? "Lagrer…" : children}
    </button>
  );
}

export function Section({ children, testId }) {
  return <section className="mb-12" data-testid={testId}>{children}</section>;
}
